export default __webpack_public_path__ + "static/media/trash.fb8afd2d.svg";